export default "__VITE_ASSET__a5a87a20__"